import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdVerifiedDomainsId = "/companies/:company_id/verified_domains/:id";

export const deleteCompaniesCompanyIdVerifiedDomainsIdCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/verified_domains",
  "/companies/:company_id/verified_domains/:id",
];
